import { render, staticRenderFns } from "./ModalSignature.vue?vue&type=template&id=1b19dfe5&scoped=true&"
import script from "./ModalSignature.vue?vue&type=script&lang=js&"
export * from "./ModalSignature.vue?vue&type=script&lang=js&"
import style0 from "./ModalSignature.vue?vue&type=style&index=0&id=1b19dfe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b19dfe5",
  null
  
)

export default component.exports